import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-face-4",
  "use": "foquz-icon-rating-face-4-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol viewBox=\"0 0 11 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-face-4\"><path d=\"M10 8a6.36 6.36 0 01-2.054 1.47 6.085 6.085 0 01-2.432.53 6.08 6.08 0 01-2.44-.492A6.346 6.346 0 011 8.07\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" /><circle cx=\"1.5\" cy=\"1.5\" r=\"1.5\" fill=\"#fff\" /><circle cx=\"9.5\" cy=\"1.5\" r=\"1.5\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol